import { handleDragSection } from '../functions/drag-section';
import scrollToElement from '../functions/scrollToElement';

export default function ProductBrandSelector() {
    const updateProductsList = async brandID => {
        const { url } = ajax;
        const formData = new FormData();
        formData.append('action', 'load_products_by_brand');
        formData.append('brand_ID', brandID);
        formData.append(
            'categoryId',
            document.getElementById('productBrands').dataset.categoryId
        );

        try {
            const response = await fetch(url, {
                method: 'POST',
                body: formData,
            });

            if (!response.ok) return;

            const result = await response.json();
            if (result.success) {
                const productCategoriesList = document.querySelector(
                    '.products-categories__list'
                );

                if (productCategoriesList) {
                    productCategoriesList.innerHTML = result.data.html;
                    scrollToElement('.product-brands-slider');
                }
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const handleTabClick = async (tab, productBrandsTabs) => {
        productBrandsTabs.forEach(t => t.classList.remove('--active'));
        tab.classList.add('--active');

        const brandID = tab.dataset.brandId;
        const dataNumber = tab.dataset.number;

        document
            .querySelectorAll('.product-brands-slider__card')
            .forEach(card => {
                card.classList.toggle(
                    '--active',
                    card.dataset.number === dataNumber
                );
            });

        if (brandID) {
            await updateProductsList(brandID);
        }
    };

    const initialize = () => {
        const productBrandsTabs = document.querySelectorAll('#productBrandTab');
        const productBrandsContainer =
            document.querySelector('.product-brands');

        if (productBrandsContainer) {
            handleDragSection('product-brands');
        }

        if (productBrandsTabs.length === 0) return;

        productBrandsTabs.forEach(tab => {
            tab.addEventListener('click', () =>
                handleTabClick(tab, productBrandsTabs)
            );
        });
    };

    initialize();
}
